import Vuex from "vuex";
import {sessionModule, SessionState} from "./stores/session";
import {applicationModule, ApplicationState} from "./stores/application";

export interface RootState {
  application: ApplicationState;
  session: SessionState;
}

export class StoreManager {

  store: Vuex.Store<any>;

  static instance: StoreManager;

  constructor() {
    this.store = new Vuex.Store<RootState>({
      modules: {
        session: sessionModule,
        application: applicationModule
      },
      strict: true
    });
  }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store.ts